import sendEventToUmami from './sendEventToUmami';
import sendToGtm from '../sendToGtm';

const trackEvent = (event: TrackEventType, name?: string) => {
  sendToGtm({ ...event, event: name });
  sendEventToUmami(event, name);
};
export default trackEvent;
